// extracted by mini-css-extract-plugin
export default {"customModal":"styles_customModal__z2P3k","container":"styles_container__JsIVy","content":"styles_content__hMnaW","title":"styles_title__VZwS3","exitBtn":"styles_exitBtn__m601b"};